async function checkDownloadAvailabilityAndGetUrl({ itemId, destinationUrl }) {
  if (!itemId || !destinationUrl) {
    return { status: 'error' }
  }

  const successResponse = {
    status: 'ok',
    downloadUrl: destinationUrl,
  }

  try {
    const response = await fetch(`/items/${itemId}/can-download-item-files`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })

    if (response.status === 403) {
      // The endpoint returns a JSON body describing which limit was hit so the
      // caller can show the right copy: a subscriber's monthly cap needs the
      // reset date, while the free daily limit shows the cap count. Fall back
      // to the free-limit reason if the body is missing or unparseable.
      const body = await response.json().catch(() => ({}))

      return {
        status: 'limit_reached',
        reason: body.reason || 'free_limit',
        resetDate: body.reset_date || null,
        limit: body.limit ?? null,
      }
    }

    return successResponse
  } catch {
    return successResponse
  }
}

export default checkDownloadAvailabilityAndGetUrl
